/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
// import NewCouponModal from "./NewCouponModal"
import {
  ApiConfigData,
} from "../../Utility/Utility";
import { useDispatch, useSelector } from "react-redux";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { ErrorMessage, Field, Form, Formik } from "formik";
import CancelIcon from "../../Assets/img/cancel-icon.svg";
import * as Yup from "yup";

const ConfirmCouponModal = ({ onCouponClose, dealCoupon, openModal }) => {
  const disptach = useDispatch();
  const identifier = useSelector(
    (state) => state?.validateLoginTokenSliceReducer?.data
  );
  const apiconfig = ApiConfigData();
  const clientCode = apiconfig?.find(
    (data) => data?.paramsKey === "clientCode"
  )?.paramsValue;
  const partnerCode = apiconfig?.find(
    (data) => data?.paramsKey === "partnerCode"
  )?.paramsValue;
  const translation = getTranslation();

  // initial state for the input fields
  const [intialValue, setInitialValue] = useState({
    salutation: "",
    name: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    city: "",
    country: "",
    acceptTerms: true,
  });

  const validationSchema = Yup.object({
    salutation: Yup.string().required("Salutation is required"),
    name: Yup.string().test(
      "name-required",
      "First name is required",
      function (value) {
        return !!this.options.context?.initialValues?.name || !!value;
      }
    ),
    lastName: Yup.string().test(
      "lastName-required",
      "Last name is required",
      function (value) {
        return !!this.options.context?.initialValues?.lastName || !!value;
      }
    ),
    phoneNumber: Yup.string().test(
      "phone-numeric",
      "Mobile number is required",
      function (value) {
        const initial = this.options.context?.initialValues?.phoneNumber;
        if (initial) return true;

        if (!value) return false; // required when no initial value
        return /^[0-9]+$/.test(value); // ONLY numeric, any length
      }
    ),
    email: Yup.string().test(
      "email-required",
      "Valid email is required",
      function (value) {
        const initial = this.options.context?.initialValues?.email;
        if (initial) return true;

        if (!value) return false;
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
      }
    ),
    city: Yup.string().test(
      "city-required",
      "City is required",
      function (value) {
        return !!this.options.context?.initialValues?.city || !!value;
      }
    ),
    country: Yup.string().test(
      "country-required",
      "Country is required",
      function (value) {
        return !!this.options.context?.initialValues?.country || !!value;
      }
    ),
  });
  //set values in form
  useEffect(() => {
    if (identifier?.memberProfile) {
      const { memberProfile } = identifier;
      setInitialValue({
        ...intialValue,
        salutation: memberProfile?.titleDescription || translation?.Mr,
        name: memberProfile?.firstName,
        lastName: memberProfile?.lastName,
        phoneNumber: memberProfile?.mobileNumber,
        email: memberProfile?.emailId,
        city: memberProfile?.address?.city,
        country: memberProfile?.address?.country || "INDIA",
      });
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [identifier?.memberProfile]);

  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // Close modal when clicking outside of it on desktop
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        window.innerWidth >= 769 &&
        !event.target.closest(".coupon-modal-container")
      ) {
        onCouponClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmit = (values) => {
    if (values) {
      openModal(null, values);
      onCouponClose();
    }
  }

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 coupon-modal-overlay"
        onClick={onCouponClose}
      ></div>
      <div
        className={`coupon-modal-container membership-container "he-90"}`}
      >
        <div className="bg-white rounded-t-2xl w-full h-full p-4 shadow-lg flex flex-col overflow-hidden">
          <div className="flex justify-between items-start sticky top-0 bg-white z-10">
            <div className="flex flex-col">
              <h2 className="title">
                {translation?.HotelMemberhsipDetailPopupHeader}
              </h2>
              <p className="sub-title">
                {translation?.HotelMemberhsipDetailPopupSubHeader}
              </p>
            </div>
            <button onClick={() => onCouponClose()}>
              <img src={CancelIcon} alt="X" />
            </button>
          </div>

          <div className="overflow-y-auto form-container">
            <Formik
              initialValues={intialValue}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
              context={{ initialValues: intialValue }}
            // validateOnChange={true}
            // validateOnBlur={true}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <Form>
                  <div className="salutation-row mb-3">
                    <div onClick={() => setFieldValue("salutation", translation?.Mr)}
                      className={`salutation ${values?.salutation === translation?.Mr ? 'salutation-bg' : ""}`}>
                      <span className="salutation-text">
                        Mr
                      </span>
                    </div>
                    <div onClick={() => setFieldValue("salutation", translation?.Mrs)}
                      className={`salutation ${values?.salutation === translation?.Mrs ? 'salutation-bg' : ""}`}>
                      <span className="salutation-text">
                        Mrs
                      </span>
                    </div>
                    <div onClick={() => setFieldValue("salutation", translation?.Ms)}
                      className={`salutation ${values?.salutation === translation?.Ms ? 'salutation-bg' : ""}`}>
                      <span className="salutation-text">
                        Ms
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 form-group ">
                      <Field
                        type="text"
                        name="name"
                        className={`form-field ${errors.name && touched.name
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder={translation?.firstNamePlaceholder || "First Name"}
                        readOnly={!!intialValue?.name}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 form-group">
                      <Field
                        type="text"
                        name="lastName"
                        className={`form-field ${errors.lastName && touched.lastName
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder={"Last Name"}
                        readOnly={!!intialValue?.lastName}
                      />
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 form-group ">
                      <Field
                        type="text"
                        name="phoneNumber"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className={`form-field ${errors.phoneNumber && touched.phoneNumber ? "is-invalid" : ""
                          }`}
                        placeholder="Mobile No."
                        readOnly={!!intialValue?.phoneNumber}
                        onKeyDown={(e) => {
                          if (intialValue?.phoneNumber) return;
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ];
                          if (allowedKeys.includes(e.key)) return;
                          if (!/^[0-9]$/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          if (intialValue?.phoneNumber) return;

                          const pastedText = e.clipboardData.getData("text");
                          if (!/^[0-9]+$/.test(pastedText)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="phoneNumber"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 form-group ">
                      <Field
                        type="text"
                        name="email"
                        className={`form-field ${errors.email && touched.email
                          ? "is-invalid"
                          : ""
                          }`}
                        // className={`form-field`}
                        placeholder={"Email ID"}
                        readOnly={!!intialValue?.email}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 form-group ">
                      <Field
                        type="text"
                        name="city"
                        className={`form-field ${errors.city && touched.city
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder={"City"}
                        readOnly={!!intialValue?.city}
                      />
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 form-group ">
                      <Field
                        type="text"
                        name="country"
                        className={`form-field ${errors.country && touched.country
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder={"Country"}
                        readOnly={!!intialValue?.country}
                      />
                      <ErrorMessage
                        name="country"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div className="accept-terms">
                    <div className="accept-checkbox">
                      <Field
                        type="checkbox"
                        name="acceptTerms"
                      />
                    </div>
                    <span className="terms-text">
                      {dealCoupon?.consentMessage}
                    </span>
                  </div>
                  <button
                    type="submit"
                    className={`confirm-button ${!values.acceptTerms ? 'disabled' : ""} `}
                    disabled={!values.acceptTerms}
                  >
                    {translation?.Confirm}
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmCouponModal;
